module.exports = __webpack_public_path__ + "7b97403f84536e43760e6ce4832efef2.svg";